import React from 'react';
import { useLocation } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

/**
 * Floating Language Switcher — position:fixed top-right pe toate paginile publice.
 *
 * 2026-05-15 — Acoperă uniform 19 pagini publice fără să edităm fiecare header.
 * Pe paginile cu Navbar (Dashboard, BrandDetail, Account) — switcher-ul din Navbar
 * e prioritar; ascundem floating-ul pentru a evita duplicare.
 *
 * Pe LandingPage header-ul propriu are deja un switcher inline → ascundem floating.
 */

// Rute unde NU afișăm floating switcher (au Navbar propriu sau switcher dedicat)
const HIDDEN_ROUTES = [
  '/dashboard',
  '/brand/',
  '/account',
  '/admin',
  '/login',
  '/register',
  '/activate',
  '/forgot-password',
  '/reset-password',
  '/billing-success',
  '/onboarding',
];

// Floating apare doar pe LandingPage și paginile publice fără Navbar
export default function FloatingLanguageSwitcher() {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  // Hide dacă suntem pe rute cu Navbar/switcher dedicat
  const hidden = HIDDEN_ROUTES.some(r => path === r || path.startsWith(r));
  if (hidden) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top, 0px) + 16px)',
        right: 16,
        zIndex: 999,
      }}
    >
      <LanguageSwitcher compact />
    </div>
  );
}
